import React, { useState, useEffect } from 'react';
import { Grow, Paper } from '@mui/material';
import SnackbarWrapper from './SnackbarWrapper';

interface AnchorOrigin {
  vertical: 'top' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
}

interface GrowMessageProps {
  message: string;
  visible: boolean;
  autoHideDuration?: number;
  onClose?: (event: any, reason: string) => void;
  elevation?: number;
  style?: React.CSSProperties;
  anchorOrigin?: AnchorOrigin;
}

export const GrowMessage: React.FC<GrowMessageProps> = ({
  message,
  visible,
  autoHideDuration,
  onClose,
  elevation = 4,
  style = {},
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' }
}) => {
  const [open, setOpen] = useState(visible);

  useEffect(() => {
    setOpen(visible);

    let timer: NodeJS.Timeout | undefined;

    if (visible && autoHideDuration) {
      timer = setTimeout(() => {
        setOpen(false);
        onClose?.(null, 'timeout');
      }, autoHideDuration);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [visible, autoHideDuration, onClose]);

  const positionStyle: React.CSSProperties = {
    position: 'fixed',
    zIndex: 1400,
    margin: 16,
    ...(anchorOrigin.vertical === 'top' ? { top: 0 } : { bottom: 0 }),
    ...(anchorOrigin.horizontal === 'left' && { left: 0 }),
    ...(anchorOrigin.horizontal === 'center' && {
      left: '50%',
      transform: 'translateX(-50%)'
    }),
    ...(anchorOrigin.horizontal === 'right' && { right: 0 }),
  };

  return (
    <Grow in={open} timeout={500}>
      <Paper
        elevation={elevation}
        style={{
          padding: 20,
          ...positionStyle,
          ...style
        }}
      >
        <SnackbarWrapper
          onClose={onClose}
          variant="success"
          message={message}
        />
      </Paper>
    </Grow>
  );
};